import React, { useRef, useState } from "react";
import ICurrentUser from "../../entities/helper/ICurrentUser";
import { usePromiseEffect } from "../../helpers/promiseEffect";
import { Col, Row } from "react-bootstrap";
import { CellContext, createColumnHelper } from "@tanstack/react-table";
import { ROW_COUNT } from "../../helpers/variableHelper";
import { cognitoUserInfo, cognitoUserToken } from "../../helpers/userHelper";
import { TextField } from "@fluentui/react";
import Loading from "../../cross/Loading";

import { ITipo_Campo } from "../../helpers/IFormHelper";
import { shortDate } from "../../helpers/dateHelper";
import Swal from "sweetalert2";
import withReactContent from "sweetalert2-react-content";
import { AdminListaPagination, IPagination } from "../../controls/AdminListaPagination";
import LIOService from "../../services/LIOService";
import IInspeccionObservacion, { IAspectoEvaluar, IEnviarLIO } from "../../entities/IInspeccionObservacion";
import { E_EstadoLIO, E_EstadoLIOAspectoEvaluar } from "../../enums/E_EstadoLIO";
import CerrarAspecto from "./components/CerrarAspecto";
import RealizarAccionAspecto from "./components/RealizarAccionAspecto";
import RenderTitle from "../../controls/RenderTitle";
import RenderValue from "../../controls/RenderValue";
const MySwal = withReactContent(Swal);

interface IAgregarLIOProps {
  readonly: boolean;
  selectedAspectoEvaluar: IAspectoEvaluar | null;
  arrayAspectos?: Array<IAspectoEvaluar>;
  is_test?: boolean;
}
const AspectosSubestandar = ({ readonly, is_test, selectedAspectoEvaluar, arrayAspectos }: IAgregarLIOProps) => {
  // NOSONAR "Se aplica en esta linea ya que SONAR nos arroja 56 como valor de complejidad cognitiva. Esta función realiza varias validaciones para la carga de las acciones, y para manejar las pruebas unitarias".
  let search = new URLSearchParams(window.location.search);
  const idLIO = parseInt(search.get("id") || "0");
  const userInfoToken = cognitoUserToken();

  const [token, setToken] = useState("");
  const [currentUser, setCurrentUser] = useState<ICurrentUser>();
  const [isLoading, setIsLoading] = useState(true);
  const [selectedAspecto, setSelectedAspecto] = useState<IAspectoEvaluar | null>(null);
  const [selectedLIO, setSelectedLIO] = useState<IInspeccionObservacion | null>(null);
  const [observaciones, setObservaciones] = useState("");
  const [arrErrorEmpty] = useState<Array<string>>([]);
  const [aspectos, setAspecto] = useState<Array<IAspectoEvaluar>>(arrayAspectos || []);
  const totalPageListAspectos = useRef<number>(0);
  const [isSendingData] = useState(false);
  const [isOpenPopUpCerrarLista, setIsOpenPopUpCerrarLista] = useState<boolean>();
  const [isOpenPopUpRealizarAccionAspecto, setIsOpenPopUpRealizarAccionAspecto] = useState<boolean>();
  const component = (titulo: string) => {
    return <RenderTitle title={titulo} />;
  };

  const componentValue = (value: any) => {
    return <RenderValue value={value} />;
  };

  const renderCerrarLista = () => {
    if (isSendingData) {
      return <Loading />;
    } else {
      return (
        <span>
          {selectedLIO?.AUTOR === currentUser?.email ||
          selectedLIO?.ENCARGADO_ZONAL?.includes(currentUser?.email || "") ||
          selectedLIO?.USUARIO_ENCARGADO_ZO === currentUser?.email ? (
            <button
              className="btn btn-sm btn-primary me-2"
              onClick={() => {
                handleCerrarLista();
              }}
              disabled={
                aspectos.some(
                  (a) =>
                    a.ID_ESTADO === E_EstadoLIOAspectoEvaluar.AccionRealizada ||
                    a.ID_ESTADO === E_EstadoLIOAspectoEvaluar.Asignado ||
                    a.ID_ESTADO === E_EstadoLIOAspectoEvaluar.Rechazado
                ) || isSendingData
              }>
              Cerrar Lista
            </button>
          ) : (
            ""
          )}
        </span>
      );
    }
  };

  const componentAcciones = (info: any) => {
    return (
      <div>
        <i
          data-testid="test1"
          className="bi bi-search iconSearch pointer colorAzul"
          title="Ver Registro"
          onClick={() => {
            if (info.row.original.ID_ESTADO === E_EstadoLIOAspectoEvaluar.Asignado) {
              setSelectedAspecto(info.row.original);
              setIsOpenPopUpRealizarAccionAspecto(true);
            } else {
              setSelectedAspecto(info.row.original);
              setIsOpenPopUpCerrarLista(true);
            }
          }}></i>
      </div>
    );
  };
  usePromiseEffect(async () => {
    setIsLoading(true);
    let token = await userInfoToken;
    setToken(token);
    let currUser = await cognitoUserInfo();
    setCurrentUser(currUser);

    if (idLIO) {
      let resultLIO = await LIOService.getLIOByID(token, idLIO);
      setSelectedLIO(resultLIO);
      await getListadoAspectosAsignadosInsObs(null, token);
    }
    setIsLoading(false);
  }, []);

  const getListadoAspectosAsignadosInsObs = async (pagination?: IPagination | null, tokenParam?: string) => {
    let paramsActive = pagination || {
      ORDENADOPOR: "ID",
      ORIENTACION: "ASC",
      PAGINA: 1,
      PAGINADO: ROW_COUNT,
    };
    let tk = tokenParam || token;
    let result = is_test
      ? { data: arrayAspectos ?? [], pages: 10 }
      : await LIOService.getListadoAspectoAsignadoInsObs(tk, {
          ...paramsActive,
          ID_INSPECCION_OBSERVACION: idLIO,
        });

    let aspectos = result.data;

    totalPageListAspectos.current = result.pages;
    setAspecto(aspectos);
  };

  const validacionCierre = (): boolean => {
    let flag = true;
    if (aspectos.some((as) => as.ID_ESTADO === E_EstadoLIOAspectoEvaluar.Rechazado)) {
      flag = false;
      MySwal.fire({
        title: <p>Sólo se puede cerrar la lista, cuando todas las acciones estén en estado cerrado o cerrado con observación</p>,
        icon: "warning",
        showConfirmButton: true,
        showCancelButton: false,
        confirmButtonText: "Aceptar",
        allowOutsideClick: false,
        allowEscapeKey: false,
        timerProgressBar: true,
        preDeny: () => {},
      });
    }
    return flag;
  };

  const handleCerrarLista = async () => {
    if (validacionCierre()) {
      MySwal.fire({
        title: <p>¿Está seguro de cerrar la lista de Inspección y Observación?</p>,
        icon: "question",
        showConfirmButton: true,
        showCancelButton: true,
        confirmButtonText: "Confirmar",
        cancelButtonText: "Cancelar",
        allowOutsideClick: false,
        allowEscapeKey: false,
        timerProgressBar: true,
        preConfirm: async () => {
          if (aspectos.some((as) => as.ID_ESTADO === E_EstadoLIOAspectoEvaluar.CerradoConObservacion) && observaciones.length === 0) {
            MySwal.fire({
              title: <p>Ingrese Observacion</p>,
              icon: "error",
            });
          } else {
            let value: IEnviarLIO = {
              ID: idLIO,
              OBSERVACION: aspectos.some((as) => as.ID_ESTADO === E_EstadoLIOAspectoEvaluar.CerradoConObservacion),
              ENVIAR_NOTIFICACION: true,
              OBSERVACIONES: observaciones,
              USUARIO_ENCARGADO_ZO: selectedLIO != undefined ? selectedLIO.USUARIO_ENCARGADO_ZO : null,
              USUARIO_ENCARGADO_ZO_DISPLAY: selectedLIO?.USUARIO_ENCARGADO_ZO_DISPLAY,
              ASPECTOS_EVALUAR: null,
            };
            await LIOService.enviarLIO(token, value);
            window.location.href = "/LIO";
          }
        },
        preDeny: () => {},
      });
    }
  };

  const columnHelperLIOAspectos = createColumnHelper<IAspectoEvaluar>();
  let columnsDefLIOAspectos = [
    columnHelperLIOAspectos.accessor((row) => row.TITULO, {
      id: "CODIGO",
      cell: (info: CellContext<IAspectoEvaluar, string>) => componentValue(info.getValue()),
      header: () => component("Codigo"),
      tipo: ITipo_Campo.text,
    } as any),
    columnHelperLIOAspectos.accessor((row) => row.NOMBRE_ELEMENTO, {
      id: "ASPECTO",
      cell: (info: CellContext<IAspectoEvaluar, string>) => componentValue(info.getValue()),
      header: () => component("Aspecto"),
      tipo: ITipo_Campo.text,
    } as any),
    columnHelperLIOAspectos.accessor((row) => row.RESPONSABLE_DISPLAY, {
      id: "USUARIO_RESPONSABLE_DISPLAY",
      cell: (info: CellContext<IAspectoEvaluar, string>) => componentValue(info.getValue()),
      header: () => component("Usuario Responsable"),
      tipo: ITipo_Campo.text,
    } as any),
    columnHelperLIOAspectos.accessor((row) => row.ACCION_REALIZADA_POR_DISPLAY, {
      id: "ACCION_REALIZADA_POR",
      cell: (info: CellContext<IAspectoEvaluar, string>) => componentValue(info.getValue()),
      header: () => component("Acción Realizada Por"),
      tipo: ITipo_Campo.text,
    } as any),
    columnHelperLIOAspectos.accessor((row) => row.FECHA_ASIGNACION, {
      id: "FECHA_ASIGNACION",
      cell: (info: CellContext<IAspectoEvaluar, Date>) => componentValue(shortDate(info.getValue())),
      header: () => component("Fecha Asignación"),
      tipo: ITipo_Campo.date,
    } as any),
    columnHelperLIOAspectos.accessor((row) => row.FECHA_HASTA, {
      id: "FECHA_HASTA",
      cell: (info: CellContext<IAspectoEvaluar, Date>) => componentValue(shortDate(info.getValue())),
      header: () => component("Fecha Hasta"),
      tipo: ITipo_Campo.date,
    } as any),
    columnHelperLIOAspectos.accessor((row) => row.FECHA_ACCIONAR, {
      id: "FECHA_ACCION_REALIZADA",
      cell: (info: CellContext<IAspectoEvaluar, Date>) => componentValue(shortDate(info.getValue())),
      header: () => component("Fecha Acción Realizada"),
      tipo: ITipo_Campo.date,
    } as any),
    columnHelperLIOAspectos.accessor((row) => row.FECHA_INGRESO_ACCION_REALIZADA, {
      id: "FECHA_INGRESO_ACCION_REALIZADA",
      cell: (info: CellContext<IAspectoEvaluar, Date>) => componentValue(shortDate(info.getValue())),
      header: () => component("Fecha Ingreso Acción Realizada"),
      tipo: ITipo_Campo.date,
    } as any),
    columnHelperLIOAspectos.accessor((row) => row.ACCION_REALIZADA, {
      id: "ACCION",
      cell: (info: CellContext<IAspectoEvaluar, string>) => componentValue(info.getValue()),
      header: () => component("Acción"),
      tipo: ITipo_Campo.text,
      enableHiding: true,
    } as any),
    columnHelperLIOAspectos.accessor((row) => row.ESTADO, {
      id: "ESTADO",
      cell: (info: CellContext<IAspectoEvaluar, string>) => componentValue(info.getValue()),
      header: () => component("Estado"),
      tipo: ITipo_Campo.text,
    } as any),
    columnHelperLIOAspectos.accessor((row) => row.ID, {
      id: "ACCIONES",
      cell: (info: CellContext<IAspectoEvaluar, string>) => componentAcciones(info),
      header: () => component("Acciones"),
      tipo: ITipo_Campo.text,
      disableSorting: true,
    } as any),
  ] as any;

  let columnsDefLIOAspectosNuevoFormato = [
    columnHelperLIOAspectos.accessor((row) => row.TITULO, {
      id: "CODIGO",
      cell: (info: CellContext<IAspectoEvaluar, string>) => componentValue(info.getValue()),
      header: () => component("Codigo"),
      tipo: ITipo_Campo.text,
    } as any),
    columnHelperLIOAspectos.accessor((row) => row.NOMBRE_ELEMENTO, {
      id: "ASPECTO",
      cell: (info: CellContext<IAspectoEvaluar, string>) => componentValue(info.getValue()),
      header: () => component("Acción"),
      tipo: ITipo_Campo.text,
    } as any),
    columnHelperLIOAspectos.accessor((row) => row.RESPONSABLE_DISPLAY, {
      id: "USUARIO_RESPONSABLE_DISPLAY",
      cell: (info: CellContext<IAspectoEvaluar, string>) => componentValue(info.getValue()),
      header: () => component("Usuario Responsable"),
      tipo: ITipo_Campo.text,
    } as any),
    columnHelperLIOAspectos.accessor((row) => row.ACCION_REALIZADA_POR_DISPLAY, {
      id: "ACCION_REALIZADA_POR",
      cell: (info: CellContext<IAspectoEvaluar, string>) => componentValue(info.getValue()),
      header: () => component("Acción Realizada Por"),
      tipo: ITipo_Campo.text,
    } as any),
    columnHelperLIOAspectos.accessor((row) => row.FECHA_ASIGNACION, {
      id: "FECHA_ASIGNACION",
      cell: (info: CellContext<IAspectoEvaluar, Date>) => componentValue(shortDate(info.getValue())),
      header: () => component("Fecha Asignación"),
      tipo: ITipo_Campo.date,
    } as any),
    columnHelperLIOAspectos.accessor((row) => row.FECHA_HASTA, {
      id: "FECHA_HASTA",
      cell: (info: CellContext<IAspectoEvaluar, Date>) => componentValue(shortDate(info.getValue())),
      header: () => component("Fecha Hasta"),
      tipo: ITipo_Campo.date,
    } as any),
    columnHelperLIOAspectos.accessor((row) => row.FECHA_ACCIONAR, {
      id: "FECHA_ACCION_REALIZADA",
      cell: (info: CellContext<IAspectoEvaluar, Date>) => componentValue(shortDate(info.getValue())),
      header: () => component("Fecha Acción Realizada"),
      tipo: ITipo_Campo.date,
    } as any),
    columnHelperLIOAspectos.accessor((row) => row.FECHA_INGRESO_ACCION_REALIZADA, {
      id: "FECHA_INGRESO_ACCION_REALIZADA",
      cell: (info: CellContext<IAspectoEvaluar, Date>) => componentValue(shortDate(info.getValue())),
      header: () => component("Fecha Ingreso Acción Realizada"),
      tipo: ITipo_Campo.date,
    } as any),
    columnHelperLIOAspectos.accessor((row) => row.ESTADO, {
      id: "ESTADO",
      cell: (info: CellContext<IAspectoEvaluar, string>) => componentValue(info.getValue()),
      header: () => component("Estado"),
      tipo: ITipo_Campo.text,
    } as any),
    columnHelperLIOAspectos.accessor((row) => row.ID, {
      id: "ACCIONES",
      cell: (info: CellContext<IAspectoEvaluar, string>) => componentAcciones(info),
      header: () => component("Acciones"),
      tipo: ITipo_Campo.text,
      disableSorting: true,
    } as any),
  ] as any;

  const error = (err: any) => {
    return arrErrorEmpty.includes(err) && "error";
  };

  return isLoading ? (
    <Loading />
  ) : (
    <div className="rounded bg-white p-2 shadow">
      <div className="container-fluid mb-4">
        <h1 className="titPrincipal colorTit">Información de Registro de Cierre</h1>
        <div className="card bg-light border mt-2">
          <div className="card-body">
            <Row>
              <Col>
                <div className="row mb-2 ajusteInput">
                  <Col xs="12" md="6" lg="2">
                    <label>Estado Inspección Observación:</label>
                  </Col>
                  <Col xs="12" md="6" lg="10">
                    <span>{selectedLIO?.ESTADO}</span>
                  </Col>
                </div>
              </Col>
            </Row>
            {(selectedLIO?.ID_ESTADO === E_EstadoLIO.Cerrado2 || selectedLIO?.ID_ESTADO === E_EstadoLIO.CerradoConObservacion) && (
              <Row>
                <Col>
                  <div className="row mb-2 ajusteInput">
                    <Col xs="12" md="6" lg="2">
                      <label>Cerrado por:</label>
                    </Col>
                    <Col xs="12" md="6" lg="10">
                      <span>{selectedLIO?.CERRADO_POR_DISPLAY}</span>
                    </Col>
                  </div>
                </Col>
              </Row>
            )}
            {(selectedLIO?.ID_ESTADO === E_EstadoLIO.Cerrado2 || selectedLIO?.ID_ESTADO === E_EstadoLIO.CerradoConObservacion) && (
              <Row>
                <Col>
                  <div className="row mb-2 ajusteInput">
                    <Col xs="12" md="6" lg="2">
                      <label>Fecha de cierre:</label>
                    </Col>
                    <Col xs="12" md="6" lg="10">
                      <span>{shortDate(selectedLIO?.FECHA_CIERRE)}</span>
                    </Col>
                  </div>
                </Col>
              </Row>
            )}
          </div>
          <div className="card bg-light border p-3 pt-2 mt-2">
            <div className="row mb-2 ajusteInput">
              <div className="col-sm-12 col-md-12 col-lg-12 mb-2">
                <h5 className="titPaneles">{selectedLIO?.NUEVO_FORMATO_FAENA ? "Acciones Asignadas" : "Aspectos Asignados"}</h5>
              </div>
              <div className="row mb-2 ajusteInput">
                {selectedLIO?.NUEVO_FORMATO_FAENA ? (
                  <AdminListaPagination
                    defaultSortBy="ID"
                    sortDirection="DESC"
                    totalPages={totalPageListAspectos}
                    resultPerPage={ROW_COUNT}
                    callback={(pagination) => {
                      getListadoAspectosAsignadosInsObs(pagination);
                    }}
                    data={aspectos}
                    reload={() => {
                      getListadoAspectosAsignadosInsObs();
                    }}
                    columnsDef={columnsDefLIOAspectosNuevoFormato}
                    hideAdd={true}
                    hideExport={true}
                  />
                ) : (
                  <AdminListaPagination
                    defaultSortBy="ID"
                    sortDirection="DESC"
                    totalPages={totalPageListAspectos}
                    resultPerPage={ROW_COUNT}
                    callback={(pagination) => {
                      getListadoAspectosAsignadosInsObs(pagination);
                    }}
                    data={aspectos}
                    reload={() => {
                      getListadoAspectosAsignadosInsObs();
                    }}
                    columnsDef={columnsDefLIOAspectos}
                    hideAdd={true}
                    hideExport={true}
                  />
                )}
              </div>
            </div>
          </div>
        </div>

        <div className="container-fluid mb-4">
          <div className="card bg-light border p-3 pt-2 mt-2">
            <div>
              <div className="col-sm-12 col-md-6 col-lg-4 mb-1">
                {selectedLIO?.ID_ESTADO === E_EstadoLIO.CerradoConObservacion ? "" : <label>Cerrar con Observación</label>}
              </div>
              <div className="col-sm-12 col-md-6 col-lg-8 mb-1">
                {selectedLIO?.ID_ESTADO === E_EstadoLIO.CerradoConObservacion ? (
                  ""
                ) : (
                  <span>
                    <div className="form-check form-check-inline">
                      <input
                        className="form-check-input"
                        type="radio"
                        name="inlineRadioOptions"
                        id="inlineRadio1"
                        value="Sí"
                        checked={aspectos.some((as) => as.ID_ESTADO === E_EstadoLIOAspectoEvaluar.CerradoConObservacion)}
                        disabled={aspectos.every((as) => as.ID_ESTADO !== E_EstadoLIOAspectoEvaluar.CerradoConObservacion)}
                      />
                      <label className="form-check-label" htmlFor="inlineRadio1">
                        Si
                      </label>
                    </div>
                    <div className="form-check form-check-inline">
                      <input
                        className="form-check-input"
                        type="radio"
                        name="inlineRadioOptions"
                        id="inlineRadio2"
                        value="No"
                        checked={aspectos.every((as) => as.ID_ESTADO !== E_EstadoLIOAspectoEvaluar.CerradoConObservacion)}
                        disabled={aspectos.some((as) => as.ID_ESTADO === E_EstadoLIOAspectoEvaluar.CerradoConObservacion)}
                      />
                      <label className="form-check-label" htmlFor="inlineRadio2">
                        No
                      </label>
                    </div>
                  </span>
                )}
                {aspectos.some((as) => as.ID_ESTADO === E_EstadoLIOAspectoEvaluar.CerradoConObservacion) && (
                  <div className="row mb-2 ajusteInput">
                    <div className="col-sm-12 col-md-12 col-lg-2 mb-2">
                      <span className="text-danger">{selectedLIO?.ID_ESTADO === E_EstadoLIO.CerradoConObservacion ? "" : <strong>(*)</strong>}</span>
                      <label>Observación:</label>
                    </div>
                    <div className="col-sm-12 col-md-12 col-lg-10 mb-2">
                      {selectedLIO?.ID_ESTADO === E_EstadoLIO.CerradoConObservacion ? (
                        <span>{selectedLIO?.CERRAR_CON_OBSERVACION}</span>
                      ) : (
                        <TextField
                          multiline
                          className={`${error("OBSERVACIONES")} borderGris`}
                          onChange={(e) => {
                            setObservaciones((e as React.ChangeEvent<HTMLTextAreaElement>).target.value);
                          }}
                          defaultValue={""}
                          maxLength={1000}></TextField>
                      )}
                    </div>
                  </div>
                )}
              </div>
            </div>
            <div className="row mb-2 ajusteInput mt-4">
              <Col xs="4" md="4" lg="4"></Col>
              <Col xs="4" md="4" lg="4" className="text-center">
                {!readonly ? renderCerrarLista() : <></>}
                <button
                  className="btn btn-sm btn-primary me-2"
                  onClick={() => {
                    window.location.href = "/lio";
                  }}
                  disabled={isSendingData}>
                  Ir al Home
                </button>
              </Col>
              <Col xs="4" md="4" lg="4"></Col>
            </div>
          </div>
        </div>
        {isOpenPopUpCerrarLista && (
          <CerrarAspecto
            token={token}
            idLIO={idLIO}
            onClose={async () => {
              setIsOpenPopUpCerrarLista(false);
              await getListadoAspectosAsignadosInsObs();
              setSelectedAspecto(null);
            }}
            aspecto={selectedAspecto}
            selectedLIO={selectedLIO}
            currentUser={currentUser || null}
          />
        )}
        {isOpenPopUpRealizarAccionAspecto && (
          <RealizarAccionAspecto
            token={token}
            idLIO={idLIO}
            onClose={async () => {
              setIsOpenPopUpRealizarAccionAspecto(false);
              await getListadoAspectosAsignadosInsObs();
              setSelectedAspecto(null);
            }}
            aspecto={selectedAspecto}
            readonly={!(selectedLIO?.ID_ESTADO === E_EstadoLIO.AccionesEnEjecucion && selectedAspecto?.RESPONSABLE == currentUser?.email)}
          />
        )}
      </div>
    </div>
  );
};
export default AspectosSubestandar;
